/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_RomanianInputs */

const en_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romanian`)
};

const fr_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roumain`)
};

const de_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rumänisch`)
};

const it_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rumeno`)
};

const ru_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`румынский`)
};

const es_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rumano`)
};

const zh_cn2_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`罗马尼亚语`)
};

const ja_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルーマニア語`)
};

const hi_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रोमानियाई`)
};

const pt_pt2_speechmatics_target_language_romanian = /** @type {(inputs: Speechmatics_Target_Language_RomanianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`romeno`)
};

/**
* | output |
* | --- |
* | "Romanian" |
*
* @param {Speechmatics_Target_Language_RomanianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_romanian = /** @type {((inputs?: Speechmatics_Target_Language_RomanianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_RomanianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_romanian(inputs)
	if (locale === "de") return de_speechmatics_target_language_romanian(inputs)
	if (locale === "it") return it_speechmatics_target_language_romanian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_romanian(inputs)
	if (locale === "es") return es_speechmatics_target_language_romanian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_romanian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_romanian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_romanian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_romanian(inputs)
	return en_speechmatics_target_language_romanian(inputs)
});